enum LeaderboardState {
    Planning = 'Planning',
    Running = 'Running',
    Ended = 'Ended',
    Canceled = 'Canceled',
    Terminated = 'Terminated',
}

export default LeaderboardState;
